var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-action',[_c('v-btn',{staticClass:"text-capitalize",attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.viewFlag(_vm.item)}}},[_vm._v("View ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }